import { Image as ImageIcon, Loader2, X } from 'lucide-react'
import { useFileThumbnailUrl } from '../files/hooks'
import type { FileAttachment } from '../files/types'

type Props = {
  contractId: number
  fileId: number
  meta: FileAttachment | undefined
  onClick: () => void
  /** Ukryj X (read-only mode) - pomiń aby pokazać przycisk odpinający. */
  onRemove?: () => void
}

/**
 * Pojedynczy thumbnail w gridzie galerii: aspect-square, obraz cover,
 * hover-X w prawym górnym rogu. Klik otwiera lightbox.
 */
export function GalleryThumbnail({ contractId, fileId, meta, onClick, onRemove }: Props) {
  // ~150px slot w gridzie (varies by breakpoint); 400 daje ostre retina + zapas na sm/md.
  const urlQ = useFileThumbnailUrl(contractId, fileId, 400)
  return (
    <div className="relative aspect-square rounded-md overflow-hidden border border-slate-200 bg-slate-50 group">
      {urlQ.isLoading ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <Loader2 size={16} className="animate-spin text-slate-400" />
        </div>
      ) : urlQ.data ? (
        <button type="button" onClick={onClick} className="block w-full h-full">
          <img
            src={urlQ.data.url}
            alt={meta?.originalFilename ?? `plik ${fileId}`}
            className="w-full h-full object-cover hover:opacity-90 transition-opacity"
            loading="lazy"
          />
        </button>
      ) : (
        <div className="absolute inset-0 flex items-center justify-center text-slate-400">
          <ImageIcon size={20} />
        </div>
      )}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onRemove() }}
          className="absolute top-1 right-1 size-6 rounded-full bg-black/60 hover:bg-rose-600 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          title="Odepnij zdjęcie"
        >
          <X size={12} />
        </button>
      )}
    </div>
  )
}
